module.exports = __webpack_public_path__ + "static/media/tools-true-false.dd1abfad.svg";